var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96027(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7751_35510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V96H96V0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.52 54.47H14.3C13.7106 54.4132 13.1546 54.1704 12.7124 53.7767C12.2701 53.383 11.9646 52.8588 11.84 52.28L11 49.57H31.84L31 52.28C30.8743 52.8619 30.5658 53.3883 30.1196 53.7823C29.6735 54.1763 29.1129 54.4173 28.52 54.47Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.98 49.57L21.41 25.34L31.84 49.57",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7 54.47H67.48C66.8871 54.4173 66.3266 54.1763 65.8804 53.7823C65.4342 53.3883 65.1257 52.8619 65 52.28L64.14 49.57H85L84.14 52.28C84.0165 52.8559 83.7139 53.3778 83.2756 53.7712C82.8373 54.1646 82.2858 54.4092 81.7 54.47Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.16 49.57L74.59 25.34L85.02 49.57",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2 25.34H79.5899",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.41 25.34H41.8",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.38 20.74L59.7999 13.32C56.6688 10.1935 52.4248 8.43738 48 8.43738C43.5751 8.43738 39.3311 10.1935 36.2 13.32L43.6199 20.74",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 12.62V18.93",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.85 83.21V30.46",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.15 30.46V83.21",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8899 83.21H60.1099C60.8448 83.1836 61.5732 83.3553 62.2189 83.7072C62.8646 84.0591 63.4038 84.5781 63.7799 85.21L65.0599 87.61H30.9399L32.2199 85.21C32.5961 84.5781 33.1353 84.0591 33.781 83.7072C34.4266 83.3553 35.1551 83.1836 35.8899 83.21Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 31.32C51.4242 31.32 54.2001 28.5441 54.2001 25.12C54.2001 21.6958 51.4242 18.92 48 18.92C44.5759 18.92 41.8 21.6958 41.8 25.12C41.8 28.5441 44.5759 31.32 48 31.32Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7751_35510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96027);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_027.9c6384e5e6d42eee33375ab598810fe5.svg";
export { ForwardRef as ReactComponent };